import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { assert } from '@sama/js-core';
import { ScrollEnablerDirective } from '../../../../cross-team-shared/scroll-enabler.directive';

export interface Feedback {
  errorTag: string;
  comment?: string;
}

@Component({
  selector: 'h3-upsert-feedback',
  imports: [
    CommonModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule,
    ScrollEnablerDirective,
  ],
  templateUrl: './upsert-feedback.component.html',
  styleUrl: './upsert-feedback.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpsertFeedbackComponent implements OnInit {
  @Input({ required: true }) possibleErrorTags!: string[];
  @Input() feedback?: Feedback;
  @Output() save = new EventEmitter<Feedback>();

  form!: FormGroup<{
    errorTag: FormControl<string | null | undefined>;
    comment: FormControl<string | null | undefined>;
  }>;

  private formBuilder = inject(FormBuilder);

  ngOnInit() {
    this.form = this.formBuilder.group({
      errorTag: [this.feedback?.errorTag, [Validators.required]],
      comment: this.feedback?.comment,
    });
  }

  saveFeedback() {
    const { errorTag, comment } = this.form.value;
    assert(typeof errorTag === 'string', 'errorTag is required');
    this.save.emit({ errorTag, comment: comment || undefined });
  }
}
